import React from "react";
import { Typography } from "@mui/material";

export default function ProductType({ productType }) {
  if (!productType || (Array.isArray(productType) && productType.length === 0)) return null;

  let displayValue;
  if (Array.isArray(productType)) {
    displayValue = productType.join(", ");
  } else {
    displayValue = productType;
  }

  return (
    <Typography variant="subtitle1" gutterBottom>
      <strong>Product Type:</strong> {displayValue}
    </Typography>
  );
}
